// Simple reducer to replace state in original FormRepository class component

export enum ModalType {
  RENAME = 'RENAME',
  DELETE = 'DELETE',
  NONE = 'NONE',
}

export interface FormRepositoryState {
  page: number;
  limit: number;
  openModal: { type: ModalType; id: any };
}

export const initialState: FormRepositoryState = {
  page: 1,
  limit: 25,
  openModal: { type: ModalType.NONE, id: null },
};

export const formRepositoryStateReducer = (
  state: FormRepositoryState,
  action,
) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return { ...state, ...action.data };
    default: {
      return state;
    }
  }
};
